import { AnalyticEvents } from '@app/enums';

export const upsellV2CardMetaData: {
    [key: string]: {
        moduleName: string;
        tagline: string;
        description: string;
        CTAText: string;
        src: string;
        embedURL: string;
        dependencyModuleTagline?: string;
        dependencyModuleSrc?: string;
        externalURL?: string;
        learnMoreEvent?: AnalyticEvents;
    };
} = {
    Benefits: {
        moduleName: 'Benefits',
        tagline: 'add-ons.benefits-v2.tagline',
        description: 'add-ons.benefits-v2.description',
        CTAText: 'add-ons.benefits-v2.CTAText',
        src: '/assets/illustrations/new-benefits.svg',
        embedURL: 'https://embed.humi.ca/benefits-3',
        learnMoreEvent: AnalyticEvents.BenefitsTrackLearnMore,
    },
    'Time Off': {
        moduleName: 'Time Off',
        tagline: 'add-ons.timeOff-v2.tagline',
        description: 'add-ons.timeOff-v2.description',
        CTAText: 'add-ons.timeOff-v2.CTAText',
        src: '/assets/illustrations/new-time-off.svg',
        embedURL: 'https://embed.humi.ca/time-off-hubspot',
        learnMoreEvent: AnalyticEvents.TimeOffLearnMore,
    },
    Payroll: {
        moduleName: 'Payroll',
        tagline: 'add-ons.payroll-v2.tagline',
        description: 'add-ons.payroll-v2.description',
        CTAText: 'add-ons.payroll-v2.CTAText',
        src: '/assets/illustrations/new-payroll.svg',
        embedURL: 'https://embed.humi.ca/payroll-hubspot',
        learnMoreEvent: AnalyticEvents.PayrollLearnMore,
    },
    Recruiting: {
        moduleName: 'Recruiting',
        tagline: 'add-ons.recruiting-v2.tagline',
        description: 'add-ons.recruiting-v2.description',
        CTAText: 'add-ons.recruiting-v2.CTAText',
        src: '/assets/illustrations/new-recruiting.svg',
        embedURL: 'https://embed.humi.ca/recruiting-hubspot',
        learnMoreEvent: AnalyticEvents.RecruitingLearnMore,
    },
    'Time Tracking': {
        moduleName: 'Time Tracking',
        tagline: 'add-ons.timeTracking-v2.tagline',
        description: 'add-ons.timeTracking-v2.description',
        CTAText: 'add-ons.timeTracking-v2.CTAText',
        src: '/assets/illustrations/new-time-tracking.svg',
        embedURL: 'https://embed.humi.ca/time-tracking',
        learnMoreEvent: AnalyticEvents.TimeTrackingLearnMore,
    },
    'Benefits Plus': {
        moduleName: 'Benefits Plus',
        tagline: 'add-ons.benefitsPlus.tagline',
        description: 'add-ons.benefitsPlus.description',
        CTAText: 'add-ons.benefitsPlus.CTAText',
        src: '/assets/illustrations/new-benefits-plus.svg',
        embedURL: 'https://embed.humi.ca/benefits-plus',
    },
    Performance: {
        moduleName: 'Performance',
        tagline: 'add-ons.performance-v2.tagline',
        description: 'add-ons.performance-v2.description',
        CTAText: 'add-ons.performance-v2.CTAText',
        src: '/assets/illustrations/new-performance.svg',
        embedURL: 'https://embed.humi.ca/performance-hubspot',
        learnMoreEvent: AnalyticEvents.PerformanceLearnMore,
    },
    'Business Insurance': {
        moduleName: 'Business Insurance',
        tagline: 'add-ons.businessInsurance-v2.tagline',
        description: 'add-ons.businessInsurance-v2.description',
        CTAText: 'add-ons.businessInsurance-v2.CTAText',
        src: '/assets/illustrations/new-business-insurance.svg',
        embedURL: 'https://embed.humi.ca/business-insurance',
        externalURL: 'https://share.hsforms.com/1qFCWp1ZBTqelOaigNDr_1g2x9cg',
    },
};
